// hygl
// components/newDialog
import HyglNewDialogBusiInfo from './src/components/newDiaLog/busiInfo'
import HyglNewDialogTabInfo from './src/components/newDiaLog/tabInfo'
// components/planYear
import HyglPlanYear from './src/components/planYear'
// components/seatComponents
import HyglSeatComponentsSeat from './src/components/seatComponents/Seat'
import HyglSeatComponentsSeatSelect from './src/components/seatComponents/seatSelect'
//WorkflowChart
import HyglWorkflowChart from './src/components/WorkflowChart/index'
// components/selectOption
import HyglSelectOption from './src/components/selectOption'
import HyglSelectOptionSelectTwo from './src/components/selectOption/selectTwo'

import HyglZhyjhForm from './src/components/hyjh/zhyjhForm'
// components/wdhy
import HyglWdhyHyhuizhi from './src/components/wdhy/components/hyhuizhi'
import HyglWdhyMeetingChange from './src/components/wdhy/components/meetingchange'
import HyglWdhyAllListActions from './src/components/wdhy/allListActions'
import HyglWdhyBm from './src/components/wdhy/bm'
import HyglWdhyDHzoperation from './src/components/wdhy/dhzoperation'
import HyglWdhyMyCreate from './src/components/wdhy/myCreate'
import HyglWdhyMyJoin from './src/components/wdhy/myJoin'
import HyglWdhyMyRegistration from './src/components/wdhy/myRegistration'
import HyglWdhyQRcode from './src/components/wdhy/QRcode'
import HyglWdhyViewMeetDetail from './src/components/wdhy/ViewMeetDetail'
// components/yt
import HyglYtAddYT from './src/components/yt/addYT'
import HyglYtChangeDb from './src/components/yt/changeDb'
import HyglFileList from './src/components/yt/components/FileList'
import HyglTaskDia from './src/components/yt/components/taskDia'
import HyglTaskJbDia from './src/components/yt/components/taskJbDia'

// components/meetInfo
import HyglMeetInfoMeetInfoDialog from './src/components/meetInfo/MeetInfoDialog'
// components/zygl
import HyglZyglKfzq from './src/components/zygl/kfzq'
// components/hytzHygl
import HyglHytzHyglComponentsdzk from './src/components/hytzHygl/componentsdzk'
import HyglHytzHyglHttzck from './src/components/hytzHygl/httzck'
import HyglHytzHyglSummaryDialog from './src/components/hytzHygl/summaryDialog'
import HyglHytzHyglMeetChangeLog from './src/components/hytzHygl/MeetChangeLog'
import HyglHytzHyglMeetFileDialog from './src/components/hytzHygl/meetFileDialog'
import HyglHytzHyglDetail from './src/components/hytzHygl/detail'
import HyglHytzHyglMeetPlaceDialog from './src/components/hytzHygl/MeetPlaceDialog'
// components/shgl
import HyglShglHthb from './src/components/shgl/hthb'
// meetingReservation
import HyglMeetingReservationListTable from './src/meetingReservation/components/meetingListTable'
import HyglMeetingReservationTable from './src/meetingReservation/components/meetingReservationTable'
import HyglMeetingReservation from './src/meetingReservation/meetingReservation'
import HyglMeetingReservationNew from './src/meetingReservation/meetingReservationNew'
// myMeeting
import HyglMyMeeting from './src/myMeeting'
// portlet
import HyglPortletMeetingReservation from './src/portlet/meetingReservation'
import HyglPortletMeetting from './src/portlet/Meetting'
import HyglPortletMeettingDialog from './src/portlet/MeettingDialog'
import HyglPortletMyMeet from './src/portlet/MyMeet'
import HyglPortletNewMyMeet from './src/portlet/NewMyMeet'
// voteManage
import HyglVoteMyParticipate from './src/voteManage/voteMyParticipate'
import HyglVotingBtn from './src/voteManage/votingBtn'
import HyglVotingContent from './src/voteManage/votingContent'
import HyglVoteResultInfo from './src/voteManage/components/VoteResultInfo'
import HyglAddMannger from './src/voteManage/components/addMannger'
import HyglLookParticipate from './src/voteManage/components/lookParticipate'
import HyglNewToupiao from './src/voteManage/components/NewToupiao'
import HyglVoteFormRange from './src/voteManage/components/VoteFormRange'
import HyglDialogStatisics from './src/voteManage/components/dialogStatisics'
import HyglVoteDialog from './src/voteManage/vote'

// hyyt
import HyglHyytHytzDbrw from './src/hyyt/hytzDbrw'
import HyglHyytHytzHyyt from './src/hyyt/hytzHyyt'
import HyglHyytToForm from './src/hyyt/workFlow/hyytForm.vue'
import HyglHyytOvertimeIssue from './src/hyyt/OvertimeIssue'
// hyyt/ytml
import HyglHyytYtmlDeptIssueReport from './src/hyyt/ytml/DeptIssueReport'
import HyglHyytYtmlTopicDetails from './src/hyyt/ytml/topicDetails'
import HyglHyytYtmlTopicDetailsHyglBg from './src/hyyt/ytml/topicDetailsHyglBg'
import HyglHyytYtmlCreateYtml from './src/hyyt/ytml/createYtml'

// 以数组的结构保存组件，便于遍历
const components = {
    HyglNewDialogBusiInfo,
    HyglNewDialogTabInfo,
    HyglPlanYear,
    HyglZhyjhForm,
    HyglSeatComponentsSeat,
    HyglSeatComponentsSeatSelect,
    HyglWorkflowChart,
    HyglSelectOption,
    HyglSelectOptionSelectTwo,
    HyglWdhyHyhuizhi,
    HyglWdhyMeetingChange,
    HyglHytzHyglDetail,
    HyglHytzHyglMeetChangeLog,
    HyglHytzHyglMeetFileDialog,
    HyglHyytOvertimeIssue,
    HyglWdhyAllListActions,
    HyglWdhyBm,
    HyglWdhyDHzoperation,
    HyglWdhyMyCreate,
    HyglWdhyMyJoin,
    HyglWdhyMyRegistration,
    HyglWdhyQRcode,
    HyglWdhyViewMeetDetail,
    HyglYtAddYT,
    HyglYtChangeDb,
    HyglFileList,
    HyglTaskDia,
    HyglTaskJbDia,
    HyglMeetInfoMeetInfoDialog,
    HyglZyglKfzq,
    HyglHytzHyglComponentsdzk,
    HyglShglHthb,
    HyglMeetingReservationListTable,
    HyglMeetingReservationTable,
    HyglMeetingReservation,
    HyglMeetingReservationNew,
    HyglMyMeeting,
    HyglPortletMeetingReservation,
    HyglPortletMeetting,
    HyglPortletMeettingDialog,
    HyglHytzHyglMeetPlaceDialog,
    HyglPortletMyMeet,
    HyglPortletNewMyMeet,
    HyglVoteMyParticipate,
    HyglVotingBtn,
    HyglVotingContent,
    HyglVoteResultInfo,
    HyglAddMannger,
    HyglLookParticipate,
    HyglNewToupiao,
    HyglVoteFormRange,
    HyglDialogStatisics,
    HyglVoteDialog,
    HyglHyytHytzDbrw,
    HyglHyytToForm,
    HyglHyytHytzHyyt,
    HyglHytzHyglSummaryDialog,
    HyglHyytYtmlDeptIssueReport,
    HyglHyytYtmlTopicDetails,
    HyglHyytYtmlTopicDetailsHyglBg,
    HyglHyytYtmlCreateYtml,
    HyglHytzHyglHttzck
}
// 定义 install 方法
const install = function(Vue) {
    if (install.installed) return
    install.installed = true
    // 遍历并注册全局组件
    Object.keys(components).forEach(key => {
        Vue.component(key, components[key])
    })
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

const $messages = require('./lang/index.js')

export default {
    // 导出的对象必须具备一个 install 方法
    install,
    // 组件列表
    ...components,
    $messages
}
